export function Marquee({ items }: { items: string[] }) {
  const row = (hidden: boolean) => (
    <div aria-hidden={hidden || undefined} className="flex shrink-0 items-center">
      {items.map((t, i) => (
        <span key={i} className="flex items-center">
          <span className="whitespace-nowrap px-8 font-display text-2xl uppercase tracking-wide text-white/85 sm:text-3xl">
            {t}
          </span>
          <span className="h-2 w-2 rotate-45 bg-eve-cyan/70" aria-hidden="true" />
        </span>
      ))}
    </div>
  );
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-white/10 bg-eve-deep/60 py-5"
    >
      <div className="marquee-track flex w-max">
        {row(false)}
        {row(true)}
      </div>
    </div>
  );
}
